import React, { FC, useState, useCallback, useEffect } from "react";
import {
  DndContext,
  closestCenter,
  MouseSensor,
  TouchSensor,
  PointerSensor,
  DragOverlay,
  useSensor,
  useSensors,
  DragStartEvent,
  DragEndEvent,
} from "@dnd-kit/core";
import { arrayMove, SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import Grid from "./Grid";
import SortableItem from "./SortableItem";
import Item from "./Item";

type SortProviderProps = {
  elements: [];
  sortKey: string;
  data: any;
  useGrid?: boolean;
  sortFunction?: undefined | void;
};
// @ts-ignore
const SortProvider: FC = (props: SortProviderProps) => {
  const [items, setItems] = useState(props.elements);
  const [activeId, setActiveId] = useState<string | null>(null);
  const [isSorting, setIsSorting] = useState(false);
  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor),
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
  );

  useEffect(() => {
    if (typeof props.sortFunction === "function") {
      // @ts-ignore
      props.sortFunction(items);
    }
  }, [items]);
  const handleDragStart = useCallback((event: DragStartEvent) => {
    setIsSorting(true);
    // @ts-ignore
    return setActiveId(event.active.id);
  }, []);
  const handleDragEnd = useCallback((event: DragEndEvent) => {
    const { active, over } = event;
    setIsSorting(false);
    if (active.id !== over?.id) {
      // @ts-ignore
      setItems((items) => {
        // @ts-ignore
        const oldIndex = items.findIndex((obj) => {
          // @ts-ignore
          return obj.id === active.id;
        });
        // @ts-ignore
        const newIndex = items.findIndex((obj) => {
          // @ts-ignore
          return obj.id === over!.id;
        });
        return arrayMove(items, oldIndex, newIndex);
      });
    }
    setActiveId(null);
  }, []);
  const handleDragCancel = useCallback(() => {
    setIsSorting(false);
    setActiveId(null);
  }, []);

  // @ts-ignore
  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
    >
      {/* @ts-ignore */}
      <SortableContext items={items} strategy={rectSortingStrategy}>
        {/* @ts-ignore */}
        {typeof props.useGrid !== "undefined" && props.useGrid ? (
          <Grid columns={5}>
            {items.map((id: any) => (
              /* @ts-ignore */
              <SortableItem
                key={id[props.sortKey]}
                id={id.id}
                data={props.data}
                item={id}
                isSorting={isSorting}
              />
            ))}
            /* @ts-ignore */
          </Grid>
        ) : (
          <>
            {items.map((id: any) => (
              /* @ts-ignore */
              <SortableItem
                key={id[props.sortKey]}
                id={id.id}
                data={props.data}
                item={id}
                isSorting={isSorting}
              />
            ))}
          </>
        )}
      </SortableContext>
      <DragOverlay adjustScale style={{ transformOrigin: "0 0 " }}>
        {/* @ts-ignore */}
        {activeId ? (
          <Item
            id={activeId}
            data={props.data}
            item={items.find((obj) => {
              // @ts-ignore
              return obj.id === activeId;
            })}
            isSorting={isSorting}
            isDragging
          />
        ) : null}
      </DragOverlay>
    </DndContext>
  );
};

export default SortProvider;
